import { useTranslation } from "@msuite/ui/localization";
import { reminderLevelLabel } from "@/components/incoming-invoices";

/** Props Interface */
interface ReminderLevelCellProps {
	level: number | null;
}

export function ReminderLevelCell({ level }: ReminderLevelCellProps) {
	/** Context */
	const { t } = useTranslation();

	/** Render */
	return <span>{t(reminderLevelLabel(level))}</span>;
}
